import { render, staticRenderFns } from "./AddRoleForm.vue?vue&type=template&id=1ec9dce8&scoped=true"
import script from "./AddRoleForm.vue?vue&type=script&lang=js"
export * from "./AddRoleForm.vue?vue&type=script&lang=js"
import style0 from "./AddRoleForm.vue?vue&type=style&index=0&id=1ec9dce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec9dce8",
  null
  
)

export default component.exports